import MuiCarousel from 'react-material-ui-carousel';
import styled from 'styled-components';

export const MuiCarouselContainer = styled(MuiCarousel)`
    .indicator-container {
        .MuiSvgIcon-root {
            font-size: 12px;
        }
    }
`;
